export interface InstagramVideo {
  id: string;
  videoUrl: string;
  thumbnailUrl: string;
  title?: string;
  description?: string;
}

export interface ApiInstagramVideo {
  id: number;
  title: string;
  description?: string;
  thumbnail_url: string;
  video_url?: string;
  page_location?: string[];
  order?: number | null;
}

export interface InstagramVideosApiResponse {
  success: boolean;
  data: {
    [region: string]: ApiInstagramVideo[];
  };
}

const instagramService = {
  async getInstagramVideos(region?: string, pageLocation?: 'home-page' | 'product-detail'): Promise<InstagramVideo[]> {
    try {
      const response = await fetch(process.env.NEXT_PUBLIC_LARAVEL_URL + '/ecommerce-data/instagram-videos/thumbnails');

      if (!response.ok) {
        console.error('Failed to fetch Instagram videos:', response.status, response.statusText);
        return [];
      }

      const apiData: InstagramVideosApiResponse = await response.json();

      if (!apiData.success || !apiData.data) {
        console.error('API returned unsuccessful response or no data');
        return [];
      }

      // If region is specified, get videos for that region
      // Otherwise, default to 'International' or get all videos
      let videosToProcess: ApiInstagramVideo[] = [];


      let changeRegionToCountry = {
        'international': 'International',
        'au': 'Australia',
        'ca': 'Canada',
        'nz': 'New Zealand',
      }
      //console.log('region', region);

      if (changeRegionToCountry[region as keyof typeof changeRegionToCountry]) {
        region = changeRegionToCountry[region as keyof typeof changeRegionToCountry];
      }      //console.log('reg1ion', region);


      if (region && apiData.data[region]) {
        videosToProcess = apiData.data[region];
      } else if (apiData.data['International']) {
        videosToProcess = apiData.data['International'];
      } else {
        // Fallback: get videos from the first available region
        const firstRegion = Object.keys(apiData.data)[0];
        if (firstRegion) {
          videosToProcess = apiData.data[firstRegion];
        }
      }

      // Filter by page location if specified
      if (pageLocation) {
        videosToProcess = videosToProcess.filter((video) =>
          video.page_location?.includes(pageLocation)
        );
      }

      // Sort by order field: videos with order values first (ascending), then null/undefined
      videosToProcess.sort((a, b) => {
        // If both have order, sort by order value
        if (a.order != null && b.order != null) {
          return a.order - b.order;
        }
        // If only a has order, a comes first
        if (a.order != null) {
          return -1;
        }
        // If only b has order, b comes first
        if (b.order != null) {
          return 1;
        }
        // Both are null/undefined, maintain original order
        return 0;
      });

      // Transform API response to match our component interface
      const transformedVideos: InstagramVideo[] = videosToProcess.map((video) => {
        const transformedVideo: InstagramVideo = {
          id: video.id.toString(),
          videoUrl: video.video_url || '',
          thumbnailUrl: video.thumbnail_url,
          title: video.title,
        };

        return transformedVideo;
      });

      //console.log('Instagram videos fetched:', transformedVideos.length, transformedVideos);
      return transformedVideos;
    } catch (error) {
      console.error('Error fetching Instagram videos:', error);
      return [];
    }
  },
};

export default instagramService;